import { useTranslation } from "react-i18next";
import "./AddApproverCell.scss";
import styles from "./AddApproverCell.module.scss";
import Icon from "../../../common/Icon/Icon";
import { useAppSelector } from "../../../../redux/hooks";

import { useMemo, useState } from "react";
import {
  Approver,
  useViewRoutingContext,
} from "../ViewRoutingContext/ViewRoutingContext";
import SearchDropdown from "../../../common/SearchDropdown/SearchDropdown";
import {
  useGetUsersListQuery,
  UserItem,
} from "../../../../redux/services/hatvAwardApprovalAPI";
import { useProfileParams } from "../../../../utils/common";

const AddApproverCell: React.FC<{disabled?: boolean}> = ({disabled = false}) => {
  const { t } = useTranslation();
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);

  const { approvers, setApprovers, aboDetails } = useViewRoutingContext();

  const { data } = useGetUsersListQuery({ affiliateCode: aboDetails.affiliateCode });

  const usersList = useMemo(
    () => (data?.body ? data.body.map(mapUserItemToApprover) : []),
    [data]
  );

  const [adding, setAdding] = useState(false);
  const [selectedApprover, setSelectedApprover] = useState<DropdownItem | null>(null);

  const dropdownItems = useMemo(
    () =>
      usersList
        .filter((app) => !approvers.some((item) => item.id === app.id))
        .map((app) => ({
          code: app.id,
          // value: `${app.name} - ${app.designation}`,
          value: app.name,
        })),
    [approvers, usersList]
  );

  const handleAddApprover = () => {
    if (!selectedApprover) return;

    const selectedItem = usersList.find(
      (user) => user.id === selectedApprover.code
    );
    if (!selectedItem) return;
    setApprovers((items) => [...items, selectedItem]);
    setSelectedApprover(null);
    setAdding(false);
  };

  const handleCancel = () => {
    setSelectedApprover(null);
    setAdding(false);
  };

  const getIconColor = (disabled?: boolean) => {
    if (disabled) return currentTheme === "light" ? "#FFFFFF" : "#8E8E93";
    return currentTheme === "light" ? "#2C2C2C" : "#D8D8D9";
  };

  return (
    <div className={`add_approver_cell ${styles.add_approver_cell}`}>
      {adding ? (
        <div
          className={`select_approver_wrapper ${styles.select_approver_wrapper}`}
        >
          <SearchDropdown
            items={dropdownItems}
            dropdownName="Select Approver"
            selectedItem={selectedApprover}
            handleSelectItemCallback={(item) => setSelectedApprover(item)}
          />
          <button className={`icon ${styles.icon}`} onClick={handleCancel}>
            <Icon
              name="cross_icon"
              color={getIconColor()}
              className={styles.close_btn}
              size={14}
            />
          </button>
          <button
            className={`icon ${styles.icon}`}
            onClick={handleAddApprover}
            disabled={!selectedApprover}
          >
            <Icon
              name="plus_white"
              color={getIconColor(!selectedApprover)}
              className={styles.close_btn}
              size={14}
            />
          </button>
        </div>
      ) : (
        <button onClick={() => setAdding(true)} disabled={disabled}>
          <Icon
            name="plus_white"
            size={14}
            color={currentTheme === "light" ? "#2c2c2c" : "#D8D8D9"}
            className={styles.plus_icon}
          />
          <span>{t(`hatv_view_routing.add_approver`)}</span>
        </button>
      )}
    </div>
  );
};

const mapUserItemToApprover = (user: UserItem): Approver => {
  return {
    id: user.nativeId,
    deleted: false,
    designation: "TBD",
    name: user.fullName,
    status: 0,
    date: new Date().toISOString()
  };
};

export default AddApproverCell;
